/** Offered playback speeds. */
export const SPEEDS = [0.25, 0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2, 2.5];
